<template>
    <!--//////// NoData ///////////////////////-->
    <div style="text-align: center">
        <!-- <img src="/assets/images/symbols/folder10.png" /> -->
        <!-- <img v-if="props.message.includes('학습')" src="/assets/images/symbols/folder10.png" /> -->

        <div style="text-align: center">
            <p class="mapNoData30 mg_bottom_70">{{ props.message }}</p>
        </div>

        <!-- <p class="txtGray text-h5">{{ props.message }}</p> -->
        <!-- <br /> -->

        <!-- <div style="text-align: center; margin: 80px"> -->
            <CusButton :type="500" :label="`학습 홈으로 이동`" @onReturn="onHome" />
        <!-- </div> -->

        <!-- <q-btn unelevated no-ripple :onClick="onHome" style="width: 35%; max-width: 533px">
            <div class="roundedBtnOutPrimary">
                <span class="roundedBtnTt30WHITE">{{ props.btnTitle }}</span>
            </div>
        </q-btn> -->

        <!-- <ComBtn :title="가나다" @onClickFn="onSubmit" /> -->
        <!-- <q-btn class="btnBig text-h6" @click="onHome" :disable="isDisableBtn" color="primary">{{ props.btnTitle }}</q-btn> -->
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import ComBtn from '@/components/quasar/cqBtn.vue';
import CusButton from '@/components/widget/CusButton.vue';
const router = useRouter();

// import { GlobalStore } from '@/store';
// const gStore = GlobalStore();

const isDisableBtn = ref(false);
const totalData = ref();
const todayStudy = ref();
const props = defineProps({
    message: {
        Type: String,
        default: '',
    },
    btnTitle: {
        Type: String,
        default: '',
    },
});

onMounted(() => {});

////////////////////////////----OnClick----////////////////////////////
const onHome = () => {
    isDisableBtn.value = true;
    router.push('/learninghome');
};
</script>

<style scoped lang="scss">
.roundedBtnOutPrimary {
    padding: 2.58vmin 6.1vmin;
}
</style>
